export default {
    setScripts(state, scripts) {
        state.scripts = scripts;
    },
    setActiveScript(state, activeScript) {
        state.activeScript = activeScript;
    },
    setManageScriptDialog(state, status) {
        state.manageScriptDialog = status;
    },
    setManageDeleteScriptDialog(state, status) {
        state.deleteScriptDialog = status;
    }
}
